import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';

import PrintView from 'components/Patient/quote/components/PrintView';
import InvoiceReadOnly from 'components/Payments/components/InvoiceReadOnly';
import Button from 'components/shared/Button/Button';
import Modal from 'components/shared/Modal/Modal';

const PatientPreviewQuote = ({ isOpen, handleClose, quote, patient }) => {
  const ref = useRef();
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      bodyClassName="!p-0"
      title="Preview Quote"
      className="!w-[1000px] bg-white"
      headButton={
        <div className="flex w-full items-center justify-end">
          <ReactToPrint
            trigger={() => (
              <Button
                variant="tertiary"
                size="small"
                type="link"
                text="Print"
                icon="printer-mono"
              />
            )}
            content={() => ref.current}
          />
        </div>
      }>
      <div ref={ref}>
        <PrintView
          patient={patient}
          practice={quote?.practice}
          createdAt={quote?.created_at}
          content={<InvoiceReadOnly invoices={[quote]} fromPatientPortal={true} />}
        />
      </div>
    </Modal>
  );
};

export default PatientPreviewQuote;
